export default {
  apiKey: "AIzaSyDuPlteafFUVjCKSsXc8Q5cwh3Lf3ITibA",
  authDomain: "kitchen-calc-724d4.firebaseapp.com",
  databaseURL: "https://kitchen-calc-724d4.firebaseio.com",
  projectId: "kitchen-calc-724d4",
  storageBucket: "kitchen-calc-724d4.appspot.com",
  messagingSenderId: "289012992567",
  appId: "1:289012992567:web:f97c6109e9bbc1a4450db2",
  measurementId: "G-K1QVP1501V"
};
